"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Icon = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var console_1 = require("../../util/console");
var Icon_module_scss_1 = __importDefault(require("./Icon.module.scss"));
/**
 * @deprecated Replace with individual React icons. See: {@link https://cultureamp.design/?path=/docs/components-icons--docs Reference}
 */
var Icon = function (_a) {
    var _b;
    var icon = _a.icon, _c = _a.inheritSize, inheritSize = _c === void 0 ? false : _c, _d = _a.role, role = _d === void 0 ? "img" : _d, _e = _a.title, title = _e === void 0 ? "" : _e, _f = _a.desc, desc = _f === void 0 ? "" : _f, classNameOverride = _a.classNameOverride, props = __rest(_a, ["icon", "inheritSize", "role", "title", "desc", "classNameOverride"]);
    var isMeaningfulImg = role === "img";
    if (isMeaningfulImg && !title) {
        (0, console_1.warn)("\n      Icon with role \"img\" missing a title attribute.\n\n      Assistive technologies that enable vision-impaired users to read web pages\n      can treat images (including icons) as either decorative or meaningful. Only\n      images with a role of \"img\" (meaningful) will be read aloud to the user.\n      These images must therefore have a aria-label attribute to provide the text\n      that will be read aloud.\n\n      Either add the missing title prop, or set this icon's role to\n      \"presentation\" to indicate it is not meaningful.\n    ");
    }
    var accessibilityProps = (_b = {
            role: role
        },
        _b["aria-hidden"] = isMeaningfulImg ? undefined : true,
        _b["aria-label"] = isMeaningfulImg && !!title ? title : undefined,
        _b);
    return (react_1["default"].createElement("svg", __assign({ className: (0, classnames_1["default"])(Icon_module_scss_1["default"].icon, classNameOverride, inheritSize && Icon_module_scss_1["default"].inheritSize), viewBox: icon.viewBox, 
        // Work around IE11 making all SVGs focusable.
        // See http://simplyaccessible.com/article/7-solutions-svgs/#acc-heading-4
        focusable: "false" }, accessibilityProps, props),
        isMeaningfulImg && !!desc ? react_1["default"].createElement("desc", null, desc) : null,
        react_1["default"].createElement("use", { xlinkHref: "#".concat(icon.id) })));
};
exports.Icon = Icon;
exports.Icon.displayName = "Icon";
//# sourceMappingURL=Icon.js.map